import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const USER_TIMEZONE = 'America/Regina';
export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ';

const formatDateTime = (time: dayjs.Dayjs | null | undefined) => {
  if (!time) return null;
  const dateTime = dayjs(time).utc().add(-6, 'hour');
  return dateTime.toISOString();
};

export const useDateFormatters = () => {
  return { formatDateTime };
};
